import { create } from "zustand";

// Store para manejar el creado, actualización y borrado de áreas.
// areasWithUsers: Array de áreas con sus usuarios. Con el formato { id: string, name: string, users: Array }
// add: Función para agregar una nueva área.
// remove: Función para eliminar un área por su ID.
// addUserToArea: Función para agregar un usuario a un área específica.
// removeUserFromArea: Función para eliminar un usuario de un área específica.

// Los ids pueden llegar como number por websocket y como string desde la API.
const isSameId = (a, b) => String(a) === String(b);

export const useAreasStore = create((set) => ({
    areasWithUsers: [], // Array de áreas con sus usuarios. Con el formato { id: string, name: string, users: [ { id: string, name: string } ] }

    setAreasWithUsers: (areasWithUsers) =>
        set({
            areasWithUsers
        }),

    addArea: (area) =>
        set((state) => ({
            areasWithUsers: [
                ...state.areasWithUsers,
                area,
            ]
        })),

    updateArea: (areaId, data) =>
        set((state) => ({
            areasWithUsers: state.areasWithUsers.map((area) =>
                area.id === areaId
                    ? { ...area, ...data }
                    : area
            )
        })),

    removeArea: (areaId) =>
        set((state) => ({
            areasWithUsers: state.areasWithUsers.filter(
                (area) => area.id !== areaId
            )
        })),

    addUserToArea: (areaId, user) =>
        set((state) => ({
            areasWithUsers: state.areasWithUsers.map((area) => {
                if (!isSameId(area.id, areaId)) return area;
                const users = area.users ?? [];
                if (users.some((u) => isSameId(u.id, user?.id))) return area;
                return { ...area, users: [...users, user] };
            }),
        })),

    updateUserInArea: (areaId, userId, data) =>
        set((state) => ({
            areasWithUsers: state.areasWithUsers.map((area) =>
                isSameId(area.id, areaId)
                    ? {
                        ...area,
                        users: (area.users ?? []).map((user) =>
                            isSameId(user.id, userId)
                                ? { ...user, ...data }
                                : user
                        ),
                    }
                    : area
            ),
        })),

    removeUserFromArea: (areaId, userId) =>
        set((state) => ({
            areasWithUsers: state.areasWithUsers.map((area) =>
                isSameId(area.id, areaId)
                    ? {
                        ...area,
                        users: (area.users ?? []).filter(
                            (user) => !isSameId(user.id, userId)
                        ),
                    }
                    : area
            ),
        })),
}));